/* eslint-disable */

/*

Accessibility monkey patch for jquery.validate 1.17.0

- Changes error labels to divs
- Announces errors via aria-live
- Allows for custom error messages in html
  Example:
    <input type="email" name="email_address" id="email_address" placeholder="Email address" required="required"
      data-error-email="Must be a valid email address"
      data-error-required="Email address is required">
*/

(function() {
  $.validator.defaults.errorElement = 'div';

  $.validator.prototype.defaultShowErrors = function() {
    var i, elements, error;
    for ( i = 0; this.errorList[ i ]; i++ ) {
      error = this.errorList[ i ];
      if ( this.settings.highlight ) {
        this.settings.highlight.call( this, error.element, this.settings.errorClass, this.settings.validClass );
      }
      this.showLabel( error.element, error.message, error.method );
    }
    if ( this.errorList.length ) {
      this.toShow = this.toShow.add( this.containers );
    }
    if ( this.settings.success ) {
      for ( i = 0; this.successList[ i ]; i++ ) {
        this.showLabel( this.successList[ i ] );
      }
    }
    if ( this.settings.unhighlight ) {
      for ( i = 0, elements = this.validElements(); elements[ i ]; i++ ) {
        this.settings.unhighlight.call( this, elements[ i ], this.settings.errorClass, this.settings.validClass );
      }
    }
    this.toHide = this.toHide.not( this.toShow );
    this.hideErrors();
    this.addWrapper( this.toShow ).show();
  };

  $.validator.prototype.showLabel = function( element, message, method ) {
    var place, group, errorID, v,
      $element = $( element ),
      error = this.errorsFor( element ),
      elementID = this.idOrName( element ),
      describedBy = $element.attr( "aria-describedby" );

    // Check if there's already an error message for this element. If there is,
    // overwrite it instead of adding another.
    // If we used aria-describedby for anything other than errors on this
    // element, this would create issues.
    if (describedBy) {
      var $ariaDescribedByError = $('#' + $element.attr("aria-describedby"));
      if ($ariaDescribedByError.length > 0) {
        error = $ariaDescribedByError;
      }
    }

    if ( method ) {
      message = $element.data('error-' + method) || message;
    }

    if ( error.length ) {

      // Refresh error/success class
      error.removeClass( this.settings.validClass ).addClass( this.settings.errorClass );

      // Replace message on existing label
      error.html( message );

      error.show();
    } else {

      // Create error element
      error = $( "<" + this.settings.errorElement + ">" )
        .attr({
           "id": elementID + "-error",
           "aria-live": "polite"
        })
        .addClass( this.settings.errorClass )
        .addClass( "validate_error_label" )
        .html( message || "" );

      // Maintain reference to the element to be placed into the DOM
      place = error;
      if ( this.settings.wrapper ) {

        // Make sure the element is visible, even in IE
        // actually showing the wrapped element is handled elsewhere
        place = error.hide().show().wrap( "<" + this.settings.wrapper + "/>" ).parent();
      }
      if ( this.labelContainer.length ) {
        this.labelContainer.append( place );
      } else if ( this.settings.errorPlacement ) {
        this.settings.errorPlacement.call( this, place, $( element ) );
      } else {
        place.insertAfter( element );
      }

      // Link error back to the element
      if ( error.is( "label" ) ) {

        // If the error is a label, then associate using 'for'
        error.attr( "for", elementID );

        // If the element is not a child of an associated label, then it's necessary
        // to explicitly apply aria-describedby
      } else if ( error.parents( "label[for='" + elementID + "']" ).length === 0 ) {
        errorID = error.attr( "id" );

        // Respect existing non-error aria-describedby
        if ( !describedBy ) {
          describedBy = errorID;
        } else if ( !describedBy.match( new RegExp( "\\b" + errorID + "\\b" ) ) ) {

          // Add to end of list if not already present
          describedBy += " " + errorID;
        }
        $( element ).attr( "aria-describedby", describedBy );

        // If this element is grouped, then assign to all elements in the same group
        group = this.groups[ element.name ];
        if ( group ) {
          v = this;
          $.each( v.groups, function( name, testgroup ) {
            if ( testgroup === group ) {
              $( "[name='" + name + "']", v.currentForm )
                .attr( "aria-describedby", error.attr( "id" ) );
            }
          } );
        }
      }
    }
    if ( !message && this.settings.success ) {
      error.text( "" );
      if ( typeof this.settings.success === "string" ) {
        error.addClass( this.settings.success );
      } else {
        this.settings.success( error, element );
      }
    }
    this.toShow = this.toShow.add( error );
  };
}(window.jQuery));